export const E_AXIS_SYSTEM_INTRO = {
    ko: {
        oxytocin: {
            title: "옥시토신 축: 정서적 유대·공감의 ‘접착제’",
            desc: "여기서의 ‘옥시토신’은 의학적 진단이 아니라, 타인의 감정을 얼마나 빠르고 깊게 ‘동기화’하는지에 대한 비유적 축입니다. 상대의 표정·톤·맥락을 감지하면 감정이 함께 움직이는 경향이 커집니다.",
            strong: "강할수록 ‘상대의 기분이 내 기분처럼’ 느껴지며, 위로·공감·정서적 동행이 자연스럽습니다.",
            love: "다만 과도하면 정서적 전염(상대 감정에 휩쓸림)로 쉽게 지치거나 관계가 ‘동반 침몰’할 수 있어, 분리선(디커플링)이 중요합니다."
        },
        vasopressin: {
            title: "바소프레신 축: 신뢰·경계·의도 파악의 ‘사회적 레이더’",
            desc: "여기서의 ‘바소프레신’은 타인의 의도/위협/정합성을 얼마나 강하게 탐지하는지에 대한 비유적 축입니다. 관계를 보호하기 위해 ‘검증/경계/전략’을 작동시키는 능력과 연결됩니다.",
            strong: "강할수록 말과 행동의 불일치, 회피, 기만 신호를 빨리 감지하며 ‘관계 보안’을 강화합니다.",
            love: "다만 과도하면 연인이 조사받는 느낌을 받을 수 있어, 따뜻한 언어(정서적 안전)를 의도적으로 먼저 넣는 균형이 필요합니다."
        }
    },
    en: {
        oxytocin: {
            title: "Oxytocin Axis: The ‘Glue’ of Emotional Bonding & Empathy",
            desc: "In this framework, ‘oxytocin’ is not a medical claim. It’s a metaphor for how quickly and deeply you synchronize with others’ emotions. The stronger it is, the more your feelings move with theirs.",
            strong: "When strong, comfort and emotional companionship come naturally—your partner feels deeply seen.",
            love: "When excessive, you risk emotional contagion and co-sinking. Decoupling (healthy separation) becomes a survival skill."
        },
        vasopressin: {
            title: "Vasopressin Axis: The ‘Social Radar’ for Trust, Boundaries, and Intent",
            desc: "Here, ‘vasopressin’ is a metaphor for how strongly you detect intent, threat, and inconsistency. It powers verification, boundaries, and strategic protection in relationships.",
            strong: "When strong, you spot contradictions, evasions, and deception cues quickly—relationship security improves.",
            love: "When excessive, partners may feel interrogated. Warm validation before analysis keeps intimacy alive."
        }
    }
};
export const E_AXIS_DATA = {
    ko: {
        1: {
            title: "영혼의 거울 (The Soul Mirror)",
            summary: "초고밀도 공감·동기화 — 강력하지만 ‘동반 침몰’ 위험",
            analysis: "상대 감정이 들어오면 ‘이해’보다 ‘동기화’가 먼저 일어나는 타입. 위로 능력은 최상급이지만 분리선이 약하면 과부하가 온다.",
            deepDive: `당신은 상대의 감정을 ‘관찰’하기보다 ‘같이 느끼는’ 쪽에 가깝습니다. 그래서 당신의 공감은 말이 아니라 존재 자체로 전달됩니다.
문제는 관계에서 상대가 무너질 때, 당신이 조율자가 아니라 ‘같이 무너지는 사람’이 될 수 있다는 점입니다. 사랑이 깊어질수록 전염도 깊어집니다.`,
            triggerMap: ["연인의 우울/분노가 길게 지속될 때", "상대가 감정적으로 의존하거나 자주 붕괴할 때", "‘내가 책임져야 한다’는 압박이 올라올 때"],
            innerMonologue: ["“지금 내가 더 버텨야 해.”", "“내가 못 지켜서 이렇게 된 건가?”", "“나도 숨이 안 쉬어진다.”"],
            relationshipLoop: "상대 감정 붕괴 → 내가 즉시 동기화 → 내 에너지 급감 → 상대를 살리려 더 투입 → 동반 침몰 위험 증가",
            whatYouNeed: ["디커플링(감정 분리) 기술", "공감 후 회복 루틴(혼자 복구 시간)", "‘내 책임’과 ‘내 영역’ 구분"],
            whatPartnerNeeds: ["당신이 무너지지 않는 안정감", "구조화된 도움(시간/범위)", "너무 떠안지 말아 달라는 합의"],
            doDont: {
                do: ["공감 후 ‘분리 문장’ 사용(‘그 감정은 네 것이고, 나는 옆에 있어’)", "하루 1회 정서 방전 체크", "관계 외 회복 루틴 확보"],
                dont: ["상대 감정을 100% 내 몫으로 흡수", "나를 갈아 넣어 관계 유지", "상대의 감정 기복을 ‘내 잘못’으로 귀결"]
            },
            scripts: [
                "“네 감정은 네 것이고, 나는 옆에서 지지할게. 다만 내가 무너지지 않게 범위를 정하자.”",
                "“지금 나도 같이 내려가고 있어. 20분만 숨 돌리고 다시 올게.”",
                "“내가 널 사랑하지만, 내가 다 책임지면 우리 둘 다 무너져.”"
            ],
            repairProtocol: [
                "1) 공감 1문장 후 ‘분리선’ 선언: “네 감정은 네 거고, 나는 옆에 있어”",
                "2) 도움 범위 정하기(시간/역할): “지금 20분만 같이 있고, 그 다음은 쉬자”",
                "3) 내 배터리 체크(0~10) 공유: “지금 나는 4/10이라 충전이 필요해”",
                "4) 재접속 약속: “쉬고 나서 다시 같이 보자”"
            ],
            growthPath: "공감의 깊이는 유지하되 ‘디커플링(분리선)’을 배우면, 동반 침몰이 ‘안정기지’로 바뀐다.",
            loveInsight: "당신의 공감은 축복이지만, 보호막 없는 공감은 당신부터 태운다."
        },

        2: {
            title: "헌신적 가디언 (The Devoted Guardian)",
            summary: "정서적 안전기지 — 다만 ‘면죄부’가 되면 착취당함",
            analysis: "관계 위협을 탐지하기보다 ‘보수/수습’에 강하다. 따뜻하지만 경계가 약해지면 불균형이 생긴다.",
            deepDive: `당신은 상대의 실수/흠을 ‘판정’하기보다 ‘관계 유지’ 관점에서 수습합니다. 그래서 연인에게는 최고의 안전기지입니다.
하지만 상대가 의도적으로 불성실하거나 기만할 때도 ‘사정이 있겠지’로 넘어가면, 당신의 선함이 면죄부가 됩니다.`,
            triggerMap: ["상대가 반복적으로 선을 넘을 때", "사과 없이 넘어가려 할 때", "내가 참고 수습하는 패턴이 고착될 때"],
            innerMonologue: ["“내가 조금만 참으면 괜찮아질 거야.”", "“나라도 지켜야지.”", "“그래도 사랑이니까…”"],
            relationshipLoop: "상대 문제 → 내가 수습 → 상대는 학습(‘괜찮구나’) → 반복 → 관계 불균형 심화",
            whatYouNeed: ["‘검증 문장’ 훈련", "반복 행동에 대한 경계 설정", "수습 역할 분담"],
            whatPartnerNeeds: ["따뜻함 + 기준(룰)", "반복 시 결과가 있다는 예측 가능성", "서로 책임지는 구조"],
            doDont: {
                do: ["반복 행동은 기록/합의", "사과+변화 조건 명확화", "‘내가 다한다’ 구조 끊기"],
                dont: ["말로만 넘어가기", "상대 성장 대신 내가 희생", "기만 신호를 ‘내 탓’으로 돌림"]
            },
            scripts: [
                "“이번은 이해하지만, 같은 일이 반복되면 나는 버티기 어렵다. 다음엔 이렇게 해줘.”",
                "“사랑은 수용이지만, 신뢰는 검증이야. 확인하고 싶어.”",
                "“내가 계속 수습하면 우리 구조가 망가져. 역할을 나누자.”"
            ],
            repairProtocol: [
                "1) 따뜻하게 시작 + 기준 한 줄: “이해해. 근데 이건 선이야”",
                "2) 반복 여부 확인: “이번이 처음이야, 반복이야?”",
                "3) ‘변화 조건’ 합의: “다음엔 ○○로 해줘”",
                "4) 역할 분담: “수습을 내가 다 하지 않게 같이 하자”"
            ],
            growthPath: "선함을 지키되 ‘기준/검증’을 추가하면, 헌신이 착취가 아니라 신뢰로 남는다.",
            loveInsight: "사랑은 수용이지만, 신뢰는 검증이다."
        },

        3: {
            title: "감정의 미아 (Directionless Antenna)",
            summary: "감정 수신은 강한데 해석/확인이 늦어 불안 루프가 생김",
            analysis: "감정은 먼저 오고, 맥락은 나중에 온다. 그래서 ‘이유 없는 불안’이 커질 때가 있다.",
            deepDive: `당신은 기류를 예민하게 받는데, 그 신호를 ‘정확한 이유’로 번역하는 속도가 늦으면 불안이 폭주합니다.
상대의 침묵/표정 변화가 곧바로 ‘거절/이별’ 시나리오로 확장될 수 있고, 확인 강박이 관계 압박이 되기도 합니다.`,
            triggerMap: ["상대의 갑작스러운 무표정/침묵", "답장 지연", "관계가 애매한 상태", "상대가 감정을 숨길 때"],
            innerMonologue: ["“내가 뭘 잘못했지?”", "“혹시 마음 식은 거야?”", "“확인해야 안 죽을 것 같아.”"],
            relationshipLoop: "불명확 신호 수신 → 불안 증폭 → 확인/사과 과잉 → 상대 압박 → 상대 거리두기 → 불안 더 증폭",
            whatYouNeed: ["감정 라벨링(‘지금은 불안’) 훈련", "팩트 확인 루틴(추측 금지)", "디커플링(상대 감정=내 감정 아님)"],
            whatPartnerNeeds: ["명확한 커뮤니케이션", "확인 질문이 공격으로 들리지 않게 톤 조절", "불안 시 ‘재접속 약속’"],
            doDont: {
                do: ["‘추측→질문’으로 전환", "불안 때 즉시 행동하지 않고 10분 대기", "관계 규칙(연락/침묵) 합의"],
                dont: ["혼자 시나리오 확장", "연속 확인 폭격", "과도한 사과로 관계 균형 붕괴"]
            },
            scripts: [
                "“지금 네 기류가 나를 불안하게 만들어. 내가 놓친 이유가 있어?”",
                "“내가 추측을 시작하면 커져. 사실을 확인하고 싶어.”",
                "“지금 불안이 올라와서 10분만 진정하고 다시 말할게.”"
            ],
            repairProtocol: [
                "1) 불안한 마음 말하기: “지금은 불안이 올라와서 추측이 시작됐어”",
                "2) 확인 질문 1개만: “지금 무슨 일 있어? 내가 놓친 게 있어?”",
                "3) 연락 가능한 시간 묻기: “언제쯤 대화 가능해?”",
                "4) 진정 루틴(10분): 호흡/산책/물 → 다시 대화"
            ],
            growthPath: "안테나는 그대로 둬도 된다. ‘표현+확인’ 두 가지만 붙이면 불안 루프가 안정 루프로 바뀐다.",
            loveInsight: "눈치가 없는 게 아니라, 너무 많이 받아서 맥락을 놓치는 것이다."
        },

        4: {
            title: "공감의 연출가 (The Empathy Director)",
            summary: "상황을 살리는 공감 연출 — 진심이 ‘기술’로 오해받을 위험",
            analysis: "감정을 느끼는 데서 끝나지 않고 ‘관계 에너지’로 조율한다. 능숙하지만 가끔 날것이 필요하다.",
            deepDive: `당신은 분위기와 감정을 빠르게 읽고, 어떤 반응이 관계를 살릴지 선택합니다. 그래서 위기에서 강하고, 사람들을 안정시킵니다.
하지만 늘 ‘조율’만 하면 연인은 “진짜 너는 어디 있어?”라고 느낄 수 있습니다.`,
            triggerMap: ["상대가 ‘진짜 마음’을 요구할 때", "당신의 공감이 너무 완벽할 때", "상대가 ‘연출 같다’고 느낄 때"],
            innerMonologue: ["“지금 이 반응이 필요해.”", "“분위기를 살려야 해.”", "“내가 무너지면 다 무너져.”"],
            relationshipLoop: "상대 감정 → 내가 조율/반전 → 단기 안정 → 상대는 진심 의심 → 더 날것 요구 → 조율이 갈등이 됨",
            whatYouNeed: ["취약함 노출(가끔은 못해도 됨)", "조율보다 ‘동행’ 선택", "완벽한 반응 강박 내려놓기"],
            whatPartnerNeeds: ["연출 없는 진짜 감정", "서툰 모습도 공유", "조율이 아닌 ‘함께 있음’"],
            doDont: {
                do: ["‘나도 힘들어’ 한 줄 공개", "해결보다 함께 침묵", "완벽한 위로 대신 진짜 말"],
                dont: ["항상 분위기 반전", "상대 감정까지 관리하려 함", "내 감정 숨기기"]
            },
            scripts: [
                "“오늘은 나도 잘 모르겠어. 그냥 옆에 있어도 돼?”",
                "“분위기 살리려 하지 않고, 너랑 같이 느껴볼게.”",
                "“나도 무섭다. 그래서 더 잘하려고 했어.”"
            ],
            repairProtocol: [
                "1) 연출 중지 선언: “오늘은 분위기 살리려 하지 않을게”",
                "2) 취약함 1줄 공개: “나도 지금은 자신이 없어/무서워”",
                "3) 동행 모드 10분(해결 금지): 그냥 같이 있기",
                "4) 그 다음에만 해결/조율로 이동"
            ],
            growthPath: "능숙함에 ‘서툰 진심’이 섞이면 신뢰가 폭발한다. 가끔은 연출이 아니라 ‘진짜’가 답이다.",
            loveInsight: "최고의 연출은 연출하지 않는 것이다."
        },

        5: {
            title: "냉철한 프로파일러 (The Cold Profiler)",
            summary: "의도·동기 분석 최상 — 다만 연인은 ‘조사받는 느낌’",
            analysis: "정서 구름을 뚫고 의도를 본다. 정확하지만 따뜻함이 없으면 단절이 온다.",
            deepDive: `당신은 감정보다 의도/정합성을 먼저 봅니다. 그래서 관계 보안에는 강하지만, 상대는 ‘취조’처럼 느낄 수 있습니다.
상대가 취약한 순간에도 ‘왜 지금 이 타이밍에?’를 먼저 떠올리면, 상대는 더 숨게 됩니다.`,
            triggerMap: ["감정 호소가 모호할 때", "말과 행동이 안 맞을 때", "책임 회피/회피 대화"],
            innerMonologue: ["“핵심이 뭐지?”", "“의도가 뭔데?”", "“팩트부터 정리하자.”"],
            relationshipLoop: "상대 감정 → 내가 분석 → 상대 수치/방어 → 더 숨김 → 내가 더 의심/분석 → 단절",
            whatYouNeed: ["정서적 안전 문장 1회 의무", "분석은 나중, 공감은 먼저", "상대의 ‘체면’ 보호"],
            whatPartnerNeeds: ["판정이 아닌 위로", "설명할 수 있는 공간", "실수해도 존중받는 느낌"],
            doDont: { do: ["‘힘들었겠다’ 먼저", "질문은 1개씩", "결론보다 안전"], dont: ["연속 추궁", "논리로 압박", "수치심 유발"] },
            scripts: [
                "“지금은 이유보다 네 마음이 먼저야. 힘들었겠다.”",
                "“확인하고 싶은 게 하나 있어. 한 가지만 물어봐도 돼?”",
                "“우린 팀이야. 판정하려는 게 아니라 이해하려는 거야.”"
            ],
            repairProtocol: [
                "1) 공감 1문장 선출력: “힘들었겠다”",
                "2) 질문은 1개씩(연속 추궁 금지)",
                "3) ‘팀 선언’: “판정이 아니라 이해하려는 거야”",
                "4) 결론은 나중: 오늘은 안전(감정)부터 복구"
            ],
            growthPath: "정확함을 유지하되 ‘따뜻한 시작’을 붙이면, 프로파일러가 심판이 아니라 보호자가 된다.",
            loveInsight: "진실은 지키지만, 다정함은 숨 쉬게 한다."
        },

        6: {
            title: "침묵의 추적자 (The Silent Tracker)",
            summary: "조용히 수집하는 맥락 — 상대는 ‘심판 대기’로 압박을 느낌",
            analysis: "즉시 폭발하지 않고 데이터를 모은다. 하지만 침묵이 공포가 될 수 있다.",
            deepDive: `당신은 의심이 생겨도 바로 말하지 않고, ‘확신’이 될 때까지 관찰합니다. 당신에겐 신중함이지만, 상대에겐 ‘알 수 없는 압박’입니다.
상대는 당신의 침묵을 해석하려다 지치고, 관계는 긴장 상태가 됩니다.`,
            triggerMap: ["거짓말/불일치 감지", "상대가 회피할 때", "내가 확신이 없을 때"],
            innerMonologue: ["“지금은 말할 때가 아니야.”", "“좀 더 봐야 해.”", "“패턴이 맞는지 확인하자.”"],
            relationshipLoop: "의심 → 침묵 수집 → 상대 불안 → 상대 방어/숨김 → 의심 강화 → 긴장 고착",
            whatYouNeed: ["실시간 로그 공유", "의심을 ‘질문’으로 전환", "침묵의 의미를 설명"],
            whatPartnerNeeds: ["불확실성 제거", "지금 무슨 상태인지 안내", "대화의 창"],
            doDont: { do: ["혼란 지점 즉시 공유", "확신 전에도 ‘느낌’은 말하기", "대화 시간 약속"], dont: ["혼자 결론", "침묵으로 압박", "증거 수집 게임화"] },
            scripts: [
                "“지금 이 부분이 헷갈려. 오해일 수도 있는데 확인하고 싶어.”",
                "“내가 조용하면 정리 중이야. 오늘 밤에 이야기하자.”",
                "“결론 내리기 전에 네 말을 듣고 싶어.”"
            ],
            repairProtocol: [
                "1) 의심을 ‘느낌’으로 공유: “이 부분이 헷갈려”",
                "2) 결론 내리기 전에 질문: “내가 오해했을 수도 있어”",
                "3) 대화 요청: “오늘 밤에 얘기할 수 있을까?”",
                "4) 합의 1개: ‘불편/의심은 24시간 내 공유’"
            ],
            growthPath: "침묵 수집을 ‘실시간 로그 공유’로 바꾸면, 압박이 사라지고 통찰이 친밀감으로 전환된다.",
            loveInsight: "당신의 침묵은 통찰이지만, 연인에겐 공포일 수 있다."
        },

        7: {
            title: "전략적 오퍼레이터 (The Strategic Operator)",
            summary: "관계 공학자 — 효율이 사랑을 ‘거래’처럼 보이게 할 수 있음",
            analysis: "해결/보상/구조로 관계를 유지한다. 정서적 무의미 시간을 인정해야 깊어진다.",
            deepDive: `당신은 관계를 ‘운영’합니다. 그래서 문제가 생기면 감정보다 해결을 먼저 찾고, 실제 행동으로 헌신을 보여줍니다.
다만 상대가 원하는 게 ‘해결’이 아니라 ‘정서적 공명’일 때, 당신의 해결책은 차갑게 들릴 수 있습니다.`,
            triggerMap: ["감정 대화가 길어질 때", "결론 없는 대화", "상대가 ‘그냥 들어줘’를 요구할 때"],
            innerMonologue: ["“그래서 결론이 뭐야?”", "“이걸 어떻게 끝내지?”", "“실제로 뭐가 필요해?”"],
            relationshipLoop: "상대 감정 → 나는 해결/최적화 → 상대는 공감 부족 → 더 감정 요구 → 나는 더 운영 모드",
            whatYouNeed: ["‘무의미한 시간’의 가치 인정", "공감/해결 구분 질문", "정서적 동행 훈련"],
            whatPartnerNeeds: ["결론 없는 대화 공간", "감정이 존중되는 느낌", "효율보다 따뜻함"],
            doDont: { do: ["“들어줄까, 해결할까?” 먼저", "결론 없는 10분 동행", "문제 해결 후 감정 케어"], dont: ["즉시 최적화", "감정 대화 축소", "성과로 사랑 증명만"] },
            scripts: [
                "“지금은 해결보다 동행이 필요해? 그냥 들어줄게.”",
                "“결론 없어도 괜찮아. 10분만 네 얘기 듣자.”",
                "“내가 해결하려고만 해서 차가웠지? 오늘은 같이 있어줄게.”"
            ],
            repairProtocol: [
                "1) 모드 확인: “지금은 들어주기야, 해결이야?”",
                "2) 10분 ‘무결론 대화’ 허용(효율 금지)",
                "3) 감정 요약 1회: “너는 지금 ○○가 힘든 거지?”",
                "4) 원하면 그때 해결로 이동"
            ],
            growthPath: "효율을 버리라는 게 아니라, ‘따뜻한 비효율’을 일정에 넣으라는 뜻이다. 그게 친밀감의 연료다.",
            loveInsight: "관계는 과제가 아니라 과정이다."
        },

        8: {
            title: "사회적 기상캐스터 (The Social Weatherman)",
            summary: "사회 기류 최상 — ‘남들 앞의 나’가 ‘둘만의 나’를 이길 위험",
            analysis: "TPO 최적화에 강하다. 프라이빗에서 진짜 집중이 필요하다.",
            deepDive: `당신은 분위기/서열/리스크를 정확히 읽고 관계를 안전하게 운용합니다. 공적인 자리에서 특히 매력적일 수 있습니다.
하지만 연인은 “남들한텐 다정한데 왜 나에겐 덜하지?”라는 온도 차를 느낄 수 있습니다.`,
            triggerMap: ["지인 모임/공적 자리 중심 데이트", "연인이 ‘나한테도 그만큼 해줘’라고 느낄 때", "외부 시선이 강할 때"],
            innerMonologue: ["“지금 분위기 관리해야 해.”", "“여기서는 이렇게 해야 안전해.”", "“사람들 눈치 봐야지.”"],
            relationshipLoop: "공적 자리에서 매력 ↑ → 사적 자리 에너지 ↓ → 연인 서운함 ↑ → ‘진심 의심’",
            whatYouNeed: ["프라이빗 포커스 시간", "연인 전용 표현(특별 대우)", "외부 시선 차단 루틴"],
            whatPartnerNeeds: ["둘만의 진심", "외부보다 우선순위", "나만 받는 애정 신호"],
            doDont: { do: ["둘만의 루틴(산책/카페) 고정", "연인에게만 쓰는 말/행동", "모임 후 1:1 케어"], dont: ["사적 자리 방전", "남 눈치가 연인보다 우선", "연인 감정 방치"] },
            scripts: [
                "“오늘은 우리 둘만의 시간이 필요해. 밖의 기류는 잠깐 끄자.”",
                "“사람들 앞의 나 말고, 너 앞의 나를 더 보여줄게.”",
                "“모임 후엔 너한테만 집중하는 시간을 만들자.”"
            ],
            repairProtocol: [
                "1) 외부 기류 OFF 선언: “지금은 우리 둘만 보자”",
                "2) 연인 우선 신호 1개(말/행동): 손 잡기/시선 고정/칭찬",
                "3) 모임 후 1:1 케어 15분(고정)",
                "4) 서운함 체크 질문: “밖에서는 내가 어땠어? 너는 어땠어?”"
            ],
            growthPath: "사회 센스를 ‘연인 전용 친밀감’으로 번역하면 완성이다. 공적 매력과 사적 진심의 온도를 맞춰라.",
            loveInsight: "외부 날씨를 맞히는 능력보다, 연인의 작은 한숨을 놓치지 않는 것이 중요하다."
        },

        9: {
            title: "담백한 리얼리스트 (The Candid Realist)",
            summary: "투명한 직진형 — 행간/비언어를 놓치면 정서적 갈증이 생김",
            analysis: "있는 그대로 믿고 말한다. 상대가 ‘알아서 알아주길’이면 충돌한다.",
            deepDive: `당신은 게임을 하지 않습니다. 비유·간접·심리전보다 ‘말한 그대로’로 관계를 운영합니다.
그래서 안정적이지만, 상대가 은유나 표정으로 신호를 보내는 타입이면 ‘못 알아듣는다’는 오해가 생깁니다.`,
            triggerMap: ["상대가 돌려 말할 때", "표정/기류로만 메시지를 보낼 때", "‘알아서’ 기대가 강할 때"],
            innerMonologue: ["“말로 해주면 알겠는데…”", "“화 안 났다면서?”", "“왜 갑자기 서운하지?”"],
            relationshipLoop: "상대의 간접 신호 → 내가 literal 해석 → 상대 실망/서운 → 더 간접화 → 단절",
            whatYouNeed: ["비언어 데이터 학습(표정/톤)", "한 번 더 묻는 확인 루틴", "상대의 표현 방식 이해"],
            whatPartnerNeeds: ["‘알아주기’ 시도", "감정 확인 질문", "부드러운 재확인"],
            doDont: { do: ["“진짜 괜찮아?” 1회 추가", "표정/톤을 데이터로 저장", "상대에게 ‘직설이 필요’ 안내"], dont: ["말 그대로만 고집", "상대의 은유를 무시", "서운함을 ‘논리’로만 처리"] },
            scripts: [
                "“네가 괜찮다 해도 표정이 달라 보여. 진짜 괜찮아?”",
                "“나는 직설이 편해. 너도 말로 해주면 내가 더 잘할 수 있어.”",
                "“내가 놓쳤다면 말해줘. 바로 수정할게.”"
            ],
            repairProtocol: [
                "1) 비언어 체크 1회 추가: “진짜 괜찮아?”",
                "2) 표정/톤을 데이터로 말하기: “표정이 달라 보여”",
                "3) 상대에게 요청: “나는 직설이 편해. 말로 해줘”",
                "4) 다음부터 ‘체크 문장’ 합의(정해진 질문 1개)"
            ],
            growthPath: "직설의 장점은 유지하고 ‘한 번 더 묻기’만 추가하면, 무심이 아니라 세심으로 보인다.",
            loveInsight: "투명함은 장점이지만, 사랑에는 행간이 있다."
        },

        10: {
            title: "고독한 관찰자 (The Solitary Observer)",
            summary: "독립적 바운더리 — 개입이 적어 ‘벽’으로 오해받기 쉬움",
            analysis: "기류와 의도를 알아도 감정 소용돌이에 들어가지 않는다. 한 발만 더 다가가면 오해가 풀린다.",
            deepDive: `당신은 상황 인지가 높지만, 정서적 결합 욕구는 상대적으로 낮을 수 있습니다. 그래서 ‘관찰자 모드’가 편합니다.
문제는 연인이 힘들 때도 관찰자에 머무르면, 상대는 거절로 느낄 수 있다는 점입니다.`,
            triggerMap: ["감정이 큰 싸움", "상대가 ‘지금 같이 있어줘’를 요구할 때", "내 개인 공간이 침해될 때"],
            innerMonologue: ["“이건 저 사람의 감정이야.”", "“내가 들어가면 더 커질 거야.”", "“거리 필요해.”"],
            relationshipLoop: "상대 감정 요구 → 나는 거리두기 → 상대는 거절로 해석 → 더 요구/실망 → 관계 거리 증가",
            whatYouNeed: ["안전한 개입 스킬(한 발만)", "바운더리 설명", "재접속 시간 약속"],
            whatPartnerNeeds: ["작은 스킨십/존재감", "‘나는 너 편’이라는 신호", "혼자 두지 않는다는 확언"],
            doDont: { do: ["손 잡기/옆에 앉기", "“지금은 같이 있을게”", "거리둘 땐 시간 약속"], dont: ["무반응 관조", "상대 감정 방치", "거리만으로 해결"] },
            scripts: [
                "“해결은 잘 모르겠는데, 일단 너 옆에 있을게.”",
                "“나는 거리가 필요할 때가 있어. 30분 후에 다시 이야기하자.”",
                "“네 편이야. 혼자 두지 않을게.”"
            ],
            repairProtocol: [
                "1) 존재감 먼저: 손/옆자리/침묵 동행 1개",
                "2) 바운더리 안내: “나는 잠깐 정리 시간이 필요해”",
                "3) 재접속 시간 약속: “○시에 다시 이야기하자”",
                "4) 끝에 한 줄: “나는 네 편이야”"
            ],
            growthPath: "벽을 허물 필요는 없다. ‘문’을 만들면 된다. 한 발만 더 들어가면 회피 오해가 풀린다.",
            loveInsight: "벽을 완전히 허물 필요는 없다. 문 하나만 만들면 된다."
        },

        11: {
            title: "이성적 번역가 (The Rational Translator)",
            summary: "감정을 ‘언어/정의’로 처리 — 상대는 ‘강의’로 느낄 수 있음",
            analysis: "감정을 느끼기보다 정의한다. 공감 문장을 먼저 넣으면 완성형.",
            deepDive: `당신은 감정을 ‘라벨링’해서 정리합니다. 그래서 큰 사건에서도 비교적 침착합니다.
하지만 상대가 원하는 게 ‘정답’이 아니라 ‘정서적 포옹’일 때, 당신의 설명은 차갑게 들립니다.`,
            triggerMap: ["상대가 위로만 원하는 순간", "상대가 논리로 설득되지 않을 때", "감정이 격해진 대화"],
            innerMonologue: ["“원인이 뭐야?”", "“정의부터 하자.”", "“이건 이렇게 해결하면 돼.”"],
            relationshipLoop: "상대 감정 호소 → 내가 분석/정의 → 상대는 무시로 해석 → 감정 폭발 → 나는 더 분석",
            whatYouNeed: ["번역 지연(30초)", "공감 문장 1회 의무", "논리보다 ‘온도’ 우선"],
            whatPartnerNeeds: ["정답 말고 위로", "감정이 존중되는 느낌", "말보다 존재감"],
            doDont: { do: ["30초 침묵+미러링", "“많이 힘들었겠다” 선출력", "해결은 나중"], dont: ["즉시 강의", "상대 감정 반박", "‘맞는 말’로 압박"] },
            scripts: [
                "“지금은 분석 말고, 먼저 힘들었겠다.”",
                "“내가 해결하려고만 했네. 지금은 그냥 들어줄게.”",
                "“30초만 같이 숨 쉬고, 그 다음에 이야기하자.”"
            ],
            repairProtocol: [
                "1) 30초 번역 지연: 말하기 전에 숨/미러링",
                "2) 공감 1문장: “그랬구나/힘들었겠다”",
                "3) 니즈 확인: “지금은 위로? 해결?”",
                "4) 그 다음에만 분석/정리"
            ],
            growthPath: "명쾌한 해답은 유지하되 ‘따뜻한 시작’을 넣으면, 강의가 아니라 위로로 전달된다.",
            loveInsight: "감정은 분석의 대상이 아니라 공유의 대상이다."
        },

        12: {
            title: "필터링된 수호자 (The Filtered Guardian)",
            summary: "내 사람에겐 올인, 밖엔 경계 — 신뢰 흔들리면 급격 냉각",
            analysis: "내집단 편향이 강하다. 신뢰가 깨지면 모드 전환이 너무 급격할 수 있다.",
            deepDive: `당신은 ‘내 사람’으로 등록되면 방어를 풀고 깊게 공감합니다. 반대로 외부에겐 경계가 강합니다.
문제는 연인에 대한 신뢰가 흔들릴 때, 보호 모드에서 의심 모드로 급전환하며 관계 온도가 급락할 수 있다는 점입니다.`,
            triggerMap: ["거짓말/숨김 신호", "신뢰 균열", "외부 유혹/삼각관계", "연인의 반복된 예외 요청"],
            innerMonologue: ["“내 사람은 내가 지켜.”", "“근데 이건 이상한데?”", "“확인되면 끝이야.”"],
            relationshipLoop: "올인 신뢰 → 균열 감지 → 급격 의심/냉각 → 상대 공포/방어 → 단절",
            whatYouNeed: ["전환 완충(즉시 단죄 금지)", "외부인/내부인 경계 완화", "확인 대화 루틴"],
            whatPartnerNeeds: ["모드 전환의 예고", "검증 과정의 공정성", "대화 기회"],
            doDont: { do: ["확인 질문 후 결론", "24시간 유예 규칙", "공감+검증 동시"], dont: ["즉시 ‘삭제’", "감정 단절로 처벌", "상대 변론 기회 박탈"] },
            scripts: [
                "“지금 신뢰가 흔들리는 지점이 있어. 결론 내리기 전에 확인하고 싶어.”",
                "“나는 급하게 단죄하지 않으려고 24시간은 유예할게.”",
                "“내가 너를 지키고 싶어서 더 정확히 확인하는 거야.”"
            ],
            repairProtocol: [
                "1) 급전환 금지(24시간 유예): “오늘은 결론 내리지 않을게”",
                "2) 사실 확인 질문 1개: “내가 불안한 지점이 이거야”",
                "3) 기준+애정 같이 말하기: “사랑하지만 이건 기준이야”",
                "4) 관계 외부에도 온도 분산(친구/취미): 집착 완화"
            ],
            growthPath: "올인 공감은 유지하되, 전환에 ‘완충 과정’을 넣으면 집착이 신뢰로 바뀐다.",
            loveInsight: "성벽은 보호가 되지만, 급히 닫히면 감옥이 된다."
        }
    },

    // EN: same depth / same fields
    en: {
        1: {
            title: "The Soul Mirror",
            summary: "Ultra-dense empathy and sync—powerful, but risks co-sinking",
            analysis: "Your system synchronizes before it ‘understands.’ Comfort is elite-level, but without boundaries you overload.",
            deepDive: `You don’t just notice emotions—you absorb them. Your empathy is felt as presence, not performance.
The risk is structural: when your partner collapses, you may collapse with them. The deeper the bond, the deeper the contagion.`,
            triggerMap: [
                "Partner’s prolonged depression/anger",
                "A partner who relies on you to regulate their emotions",
                "Feeling ‘responsible’ for their mental state"
            ],
            innerMonologue: [
                "“I have to hold this together.”",
                "“Did I fail them?”",
                "“I can’t breathe either.”"
            ],
            relationshipLoop:
                "Partner sinks → you sync immediately → your energy drops → you over-invest to rescue → co-sinking risk increases",
            whatYouNeed: ["Decoupling (emotional separation) skills", "A recovery ritual after intense empathy", "Clear boundaries: what’s yours vs theirs"],
            whatPartnerNeeds: ["A stable anchor who doesn’t collapse", "Structured support (scope/time)", "Agreements that you won’t carry 100%"],
            doDont: {
                do: [
                    "Use boundary language: “That feeling is yours; I’m here beside you.”",
                    "Run a daily empathy-battery check",
                    "Protect non-relationship recovery time"
                ],
                dont: [
                    "Absorb 100% of their emotion as your duty",
                    "Burn yourself to keep the relationship afloat",
                    "Turn their mood into your self-blame"
                ]
            },
            scripts: [
                "“Your feelings are yours. I’m here to support you—without sinking with you.”",
                "“I’m starting to go down with you. Give me 20 minutes to reset, then I’m back.”",
                "“I love you, but if I carry everything, we both collapse.”"
            ],
            repairProtocol: [
                "1) Validate once, then set a separation line (“Your feeling is yours; I’m here.”)",
                "2) Define support scope (time/role): “20 minutes with you, then I reset.”",
                "3) Share battery (0–10) so it’s visible",
                "4) Promise reconnection after reset"
            ],
            growthPath: "Keep the empathy, add decoupling. That turns co-sinking into a secure base.",
            loveInsight: "Empathy is divine comfort—but without a shield, it burns the empath first."
        },

        2: {
            title: "The Devoted Guardian",
            summary: "A textbook secure base—yet can become a ‘pardon system’ that enables exploitation",
            analysis: "You repair rather than detect threats. Warmth is massive; boundaries must be explicit.",
            deepDive: `You instinctively patch the relationship. You absorb tension, soothe pain, and keep the bond intact.
But if your partner is repeatedly unfair or deceptive, your “There must be a reason” becomes permission. The imbalance grows quietly.`,
            triggerMap: [
                "Repeated boundary crossings",
                "No accountability / no repair from the partner",
                "A one-sided ‘you fix, they repeat’ pattern"
            ],
            innerMonologue: [
                "“If I endure a bit, it’ll stabilize.”",
                "“Someone has to keep it together.”",
                "“It’s love… so I should accept.”"
            ],
            relationshipLoop:
                "Partner harms → you repair → partner learns ‘it’s fine’ → repeats → imbalance deepens",
            whatYouNeed: ["Verification language", "Boundaries for repetition", "Shared repair responsibilities"],
            whatPartnerNeeds: ["Warmth + standards", "Predictable consequences for repeated behavior", "A shared responsibility structure"],
            doDont: {
                do: ["Document/agree on recurring issues", "Clarify apology + behavior change conditions", "Stop being the sole repairer"],
                dont: ["Let things slide verbally with no change", "Sacrifice yourself for their growth", "Convert deception signals into self-blame"]
            },
            scripts: [
                "“I can understand this once. If it repeats, I can’t stay okay. Let’s change it.”",
                "“Love accepts—but trust verifies. I need clarity.”",
                "“If I keep repairing alone, our structure breaks. Let’s share the work.”"
            ],
            repairProtocol: [
                "1) Warm start + one boundary line",
                "2) Check repetition: first time or pattern?",
                "3) Agree on one behavior change for next time",
                "4) Split repair work so you don’t carry it all"
            ],
            growthPath: "Add standards to kindness. Then devotion becomes trust, not exploitation.",
            loveInsight: "Love is acceptance. Trust is verification."
        },

        3: {
            title: "Directionless Antenna",
            summary: "High emotional reception, slow interpretation—anxiety loops form",
            analysis: "Emotion arrives first, context arrives later. That gap can generate ‘reasonless fear.’",
            deepDive: `You pick up micro-signals instantly, but if you can’t translate them into a clear reason quickly, anxiety fills the gap.
Silence becomes a breakup story. A face change becomes rejection. Confirmation seeking can then become pressure—pushing the partner away and proving the fear.`,
            triggerMap: ["Sudden silence/flat face", "Late replies", "Ambiguous relationship status", "Partner hides emotions"],
            innerMonologue: ["“What did I do?”", "“Are they leaving?”", "“I need to confirm or I’ll explode.”"],
            relationshipLoop:
                "Unclear signal → anxiety spikes → checking/apologizing → partner feels pressured → partner distances → anxiety spikes more",
            whatYouNeed: ["Affective labeling (“this is anxiety”)", "Fact-checking routine (no guessing)", "Decoupling (their mood ≠ your worth)"],
            whatPartnerNeeds: ["Clear communication norms", "A gentle tone for checks", "Reconnection promises during pauses"],
            doDont: {
                do: ["Replace guessing with one clear question", "Wait 10 minutes before acting", "Agree on silence/reply norms"],
                dont: ["Expand stories alone", "Send multiple checks in a row", "Collapse into over-apology"]
            },
            scripts: [
                "“Your vibe is making me anxious—am I missing a reason?”",
                "“I’m starting to guess. I’d rather ask for facts.”",
                "“I’m anxious right now. Give me 10 minutes to calm, then I’ll talk.”"
            ],
            repairProtocol: [
                "1) Name the feeling: “I’m guessing—anxiety is up.”",
                "2) Ask ONE clarity question",
                "3) Ask when to talk (“Can we talk later?”)",
                "4) 10-minute regulation reset, then reconnect"
            ],
            growthPath: "Don’t lower the antenna—upgrade interpretation: express + verify breaks the anxiety loop.",
            loveInsight: "It’s not lack of intuition—it’s too much input without context."
        },

        4: {
            title: "The Empathy Director",
            summary: "Active emotional harmonizer—risk of being seen as ‘performative’",
            analysis: "You don’t just feel; you orchestrate. Skillful, but rawness is required for trust.",
            deepDive: `You read the room fast and select the response that saves the relationship’s temperature. In crises, you’re powerful.
But if you always ‘direct,’ your partner may wonder where the real you is. Perfect empathy can paradoxically feel like a technique.`,
            triggerMap: ["Partner asks for ‘the real you’", "Your support feels too flawless", "Partner says it feels staged"],
            innerMonologue: ["“This reaction will stabilize us.”", "“I must shift the mood.”", "“If I fall, everything falls.”"],
            relationshipLoop:
                "Partner emotion → you orchestrate → short-term relief → partner doubts sincerity → demands rawness → orchestration becomes conflict",
            whatYouNeed: ["Show vulnerability sometimes", "Choose ‘being with’ over ‘fixing’", "Drop the perfection reflex"],
            whatPartnerNeeds: ["Unedited emotions", "Clumsy honesty", "Presence without management"],
            doDont: {
                do: ["Say one vulnerable line", "Sit in silence together", "Share your fear/limits"],
                dont: ["Always flip the mood", "Manage partner’s feelings", "Hide your own emotions"]
            },
            scripts: [
                "“I don’t have the perfect response. Can I just be here?”",
                "“I won’t try to turn this around—I’ll feel it with you.”",
                "“I was trying so hard because I was scared too.”"
            ],
            repairProtocol: [
                "1) Stop directing: “I won’t try to flip the mood.”",
                "2) Share one vulnerable line",
                "3) 10 minutes of presence (no fixing)",
                "4) Then move into coordination/solutions"
            ],
            growthPath: "Mix skill with raw sincerity. Vulnerability makes your empathy feel real.",
            loveInsight: "The best direction is often not directing."
        },

        5: {
            title: "The Cold Profiler",
            summary: "Intent-first x-ray—partners can feel interrogated",
            analysis: "You pierce emotional fog and see motives. Accurate, but warmth must lead.",
            deepDive: `You prioritize intent and consistency. That protects the relationship’s security, but it can harm emotional safety.
If your first move in vulnerability is “why now?” your partner may feel shame and retreat—creating more secrecy and more suspicion.`,
            triggerMap: ["Vague emotional appeals", "Inconsistency", "Responsibility avoidance"],
            innerMonologue: ["“What’s the real agenda?”", "“What’s the core?”", "“Facts first.”"],
            relationshipLoop:
                "Partner emotion → you analyze → partner feels judged → partner hides → you suspect more → intimacy collapses",
            whatYouNeed: ["Mandatory validation first", "One-question-at-a-time", "Protect partner’s face (avoid shame)"],
            whatPartnerNeeds: ["Comfort not courtroom", "Space to explain", "Respect even when messy"],
            doDont: {
                do: ["Lead with “that sounds hard”", "Ask one clarifying question", "Declare team-intent"],
                dont: ["Rapid-fire questions", "Logic pressure", "Shame-based ‘gotchas’"]
            },
            scripts: [
                "“Before reasons—this sounds really hard.”",
                "“I have one question to understand. Is that okay?”",
                "“I’m not judging you. I’m trying to understand us.”"
            ],
            repairProtocol: [
                "1) Lead with one validation line",
                "2) One question at a time (no rapid-fire)",
                "3) Team declaration: understanding, not verdict",
                "4) Restore emotional safety before conclusions"
            ],
            growthPath: "Keep accuracy, add warm entry. Then profiling becomes protection—not interrogation.",
            loveInsight: "Truth can protect love—kindness makes it breathe."
        },

        6: {
            title: "The Silent Tracker",
            summary: "Collects context quietly—silence becomes pressure",
            analysis: "You wait for certainty. Your partner waits for judgment.",
            deepDive: `You don’t confront fast. You observe until the pattern is clear. That’s prudent for you.
For your partner, it can feel like living under invisible surveillance. Unnamed suspicion turns into atmosphere pressure.`,
            triggerMap: ["Deception cues", "Avoidant communication", "Uncertainty without enough data"],
            innerMonologue: ["“Not yet.”", "“I need more context.”", "“Let me verify the pattern.”"],
            relationshipLoop:
                "Suspicion → silent gathering → partner anxiety → partner defensive hiding → suspicion strengthens → tension locks in",
            whatYouNeed: ["Real-time log sharing", "Convert suspicion into a question", "Explain what silence means"],
            whatPartnerNeeds: ["Lower uncertainty", "Status updates", "A dialogue window"],
            doDont: {
                do: ["Share confusion early", "Say ‘I might be wrong’ + ask", "Set a talk time"],
                dont: ["Conclude alone", "Pressure via silence", "Turn it into evidence-game"]
            },
            scripts: [
                "“This part confuses me. I might be wrong, but I want to clarify.”",
                "“If I’m quiet, I’m processing. Let’s talk tonight.”",
                "“I don’t want to conclude without hearing you.”"
            ],
            repairProtocol: [
                "1) Share suspicion as confusion (“I’m unsure here”)",
                "2) Ask before concluding (“I may be wrong”)",
                "3) Ask for a moment to talk",
                "4) Rule: doubts must be shared within 24 hours"
            ],
            growthPath: "Replace silent tracking with real-time logs. Pressure drops; intimacy rises.",
            loveInsight: "Your silence can be wisdom to you—and fear to them."
        },

        7: {
            title: "The Strategic Operator",
            summary: "Relationship engineer—efficiency can feel transactional",
            analysis: "You solve and optimize. Your partner may need ‘warm inefficiency.’",
            deepDive: `You keep relationships running. You prefer solutions, structure, and tangible proof of love.
But when a partner wants resonance—not resolution—your competence can sound cold. They may feel ‘managed’ instead of loved.`,
            triggerMap: ["Long emotional talks", "No-conclusion conversations", "“Just listen” requests"],
            innerMonologue: ["“What’s the outcome?”", "“How do we end this?”", "“What do you need practically?”"],
            relationshipLoop:
                "Partner emotion → you optimize → partner feels unseen → demands more emotion → you manage harder",
            whatYouNeed: ["Accept non-productive time", "Ask comfort vs solution", "Practice emotional companionship"],
            whatPartnerNeeds: ["Space for feelings", "Warmth over efficiency", "Presence without fixing"],
            doDont: {
                do: ["Ask what mode they need", "Offer 10 minutes of no-fixing listening", "After solving, do emotional aftercare"],
                dont: ["Instant optimization", "Minimize emotional talk", "Prove love only via tasks"]
            },
            scripts: [
                "“Do you want solutions—or just me listening?”",
                "“We don’t need a conclusion. I’ll stay with you for 10 minutes.”",
                "“I was trying to fix it. Today I’ll just be with you.”"
            ],
            repairProtocol: [
                "1) Ask mode: comfort or solution?",
                "2) Allow 10 minutes of no-conclusion talk",
                "3) Reflect one feeling back",
                "4) Only then move to solutions"
            ],
            growthPath: "Add ‘warm inefficiency’ to your efficiency. That’s intimacy fuel.",
            loveInsight: "A relationship isn’t a task to solve—it’s a process to savor."
        },

        8: {
            title: "The Social Weatherman",
            summary: "Elite social-context reading—public charm can outshine private intimacy",
            analysis: "You optimize for context. Your partner needs private priority signals.",
            deepDive: `You read hierarchy, vibe, and risk. In public, you’re often at your best.
But if most of your energy goes to social correctness, your partner can feel emotionally underfed in private—where intimacy is built.`,
            triggerMap: ["Public-centered dates", "Partner says ‘give me that energy too’", "High external gaze pressure"],
            innerMonologue: ["“Manage the vibe.”", "“Keep it safe socially.”", "“Eyes are on us.”"],
            relationshipLoop:
                "Public charm high → private energy low → partner resentment → sincerity doubt → distance",
            whatYouNeed: ["Private focus rituals", "Partner-only signals", "Post-social aftercare"],
            whatPartnerNeeds: ["Priority over outsiders", "Exclusive affection", "Time with no audience"],
            doDont: {
                do: ["Schedule private rituals", "Use one partner-only phrase/action", "After gatherings, give 1:1 care"],
                dont: ["Go flat in private", "Prioritize gaze over partner", "Skip repair after social events"]
            },
            scripts: [
                "“Tonight is ours—let’s turn off the outside weather.”",
                "“I’ll show you more of ‘me with you,’ not ‘me for people.’”",
                "“After the gathering, I want time just for us.”"
            ],
            repairProtocol: [
                "1) Turn off external vibes: “Just us now.”",
                "2) Give one priority signal (touch/eye contact/praise)",
                "3) 15-minute post-social 1:1 aftercare",
                "4) Ask: “Did you feel second-place?”"
            ],
            growthPath: "Translate social intelligence into partner-exclusive intimacy.",
            loveInsight: "Don’t let perfect weather reports make your own garden wither."
        },

        9: {
            title: "The Candid Realist",
            summary: "Transparent literal processing—misses subtext and micro-signals",
            analysis: "You don’t play games. Without subtext skills, partners can feel emotionally thirsty.",
            deepDive: `You take words at face value and you speak plainly. That makes you consistent and low-drama.
But if your partner communicates via hints, tone, and metaphors, they may feel unseen—even when you are sincere.`,
            triggerMap: ["Indirect communication", "Metaphors instead of requests", "‘You should know’ expectations"],
            innerMonologue: ["“If you tell me directly, I can do it.”", "“You said you’re fine.”", "“Why didn’t you just say it?”"],
            relationshipLoop:
                "Partner hints → you interpret literally → partner feels unseen → hints more → distance grows",
            whatYouNeed: ["Nonverbal data learning", "One extra check question", "Agreement on direct requests"],
            whatPartnerNeeds: ["‘I’m trying to read you’ effort", "Gentle reconfirmation", "Emotion-check questions"],
            doDont: {
                do: ["Ask once more: ‘are you really okay?’", "Treat tone/face as data", "Tell them you need direct words"],
                dont: ["Insist only literal text matters", "Dismiss metaphors", "Argue feelings via logic only"]
            },
            scripts: [
                "“You say you’re okay, but your face says otherwise—are you truly okay?”",
                "“Direct words help me love you better. Can you say what you need?”",
                "“If I missed the subtext, tell me—I’ll adjust.”"
            ],
            repairProtocol: [
                "1) Add one extra check: “Are you really okay?”",
                "2) Name the nonverbal data (“Your face/tone changed”)",
                "3) Request direct words (you work best with explicitness)",
                "4) Agree on one fixed check phrase"
            ],
            growthPath: "Keep literal honesty—add one extra check and you become ‘attentive,’ not ‘oblivious.’",
            loveInsight: "Transparency is a strength—but love often lives between the lines."
        },

        10: {
            title: "The Solitary Observer",
            summary: "Strong boundaries—low intervention gets misread as a wall",
            analysis: "You can read the vibe but you don’t enter the whirlpool. One step closer prevents rejection-misreads.",
            deepDive: `Your boundary system is strong. You prefer observing to immersing.
In love, that can be misread as avoidance. Partners often don’t need solutions—they need your presence in the storm.`,
            triggerMap: ["High-emotion moments", "“Be here with me now” requests", "Boundary intrusion (time/space)"],
            innerMonologue: ["“This is their emotion.”", "“If I enter, it escalates.”", "“I need distance.”"],
            relationshipLoop:
                "Partner asks presence → you distance → partner feels rejected → escalates/withdraws → intimacy drops",
            whatYouNeed: ["Safe micro-intervention", "Explain boundaries", "Time-bound pauses"],
            whatPartnerNeeds: ["Physical presence signals", "‘I’m on your side’ confirmation", "No abandonment in crisis"],
            doDont: {
                do: ["Hold hand / sit closer", "Say ‘I’m here’", "If pausing, set a return time"],
                dont: ["Pure observation silence", "Leaving them alone in distress", "Using distance as the only tool"]
            },
            scripts: [
                "“I don’t know the answer yet, but I’m here with you.”",
                "“I need 30 minutes, then I’ll come back and talk.”",
                "“I’m on your side. I won’t leave you alone.”"
            ],
            repairProtocol: [
                "1) Presence first (sit closer/hold hand)",
                "2) Explain boundary briefly",
                "3) Set a return time",
                "4) Close with: “I’m on your side.”"
            ],
            growthPath: "You don’t need to remove the wall—build a door. One step closer prevents rejection misreads.",
            loveInsight: "A fortress can protect—but a door creates intimacy."
        },

        11: {
            title: "The Rational Translator",
            summary: "Turns emotions into definitions—partners can feel lectured",
            analysis: "You label and explain. Add warmth-first to avoid sounding like a class.",
            deepDive: `You process feelings by naming and structuring them. You regain composure quickly.
But when your partner wants comfort, analysis feels like distance. ‘Right words’ aren’t always ‘warm words.’`,
            triggerMap: ["Partner wants comfort only", "High emotional flooding", "When your logic contradicts their feeling"],
            innerMonologue: ["“Let’s define the cause.”", "“We can solve this.”", "“Explain it clearly.”"],
            relationshipLoop:
                "Partner seeks comfort → you translate/lecture → partner feels unseen → escalates → you translate harder",
            whatYouNeed: ["30-second delay", "Mandatory validation line", "Prioritize warmth over correctness"],
            whatPartnerNeeds: ["Comfort before solutions", "Permission to feel messy", "Presence not lectures"],
            doDont: {
                do: ["Mirror + 30 seconds", "Say ‘that must be hard’ first", "Ask: comfort or solution?"],
                dont: ["Immediate explanation", "Correcting their feelings", "Using ‘rightness’ as pressure"]
            },
            scripts: [
                "“Before analysis—this must be hard.”",
                "“I was trying to fix it. I’ll just listen right now.”",
                "“Let’s breathe 30 seconds together, then talk.”"
            ],
            repairProtocol: [
                "1) 30-second translation delay (breathe, mirror)",
                "2) One validation line",
                "3) Ask: comfort or solution?",
                "4) Then translate/analyze"
            ],
            growthPath: "Your clarity stays—your warmth arrives earlier. That stops ‘lecture mode.’",
            loveInsight: "Emotions are for sharing, not scoring."
        },

        12: {
            title: "The Filtered Guardian",
            summary: "All-in for ‘my person,’ guarded for outsiders—trust cracks can trigger sudden cold mode",
            analysis: "In-group bias is strong. Add transition buffering to prevent ‘instant deletion.’",
            deepDive: `You open completely for your chosen person, but stay guarded outside.
If trust cracks, the system can flip fast from devotion to suspicion, and that coldness can feel terrifying to the partner.`,
            triggerMap: ["Lies/omissions", "Trust fractures", "Triangulation/third-party threats", "Repeated exception requests"],
            innerMonologue: ["“I protect my person.”", "“This feels off.”", "“If confirmed, it’s over.”"],
            relationshipLoop:
                "All-in trust → crack detected → sudden suspicion/coldness → partner panics/defends → rupture deepens",
            whatYouNeed: ["No-instant-verdict rule", "Soften insider/outsider boundary", "A fair verification conversation"],
            whatPartnerNeeds: ["Warning before shutdown", "A chance to explain", "Clear standards and process"],
            doDont: {
                do: ["Ask before concluding", "24-hour buffer rule", "Say care + standard together"],
                dont: ["Instant deletion", "Punishment via emotional cutoff", "No appeal/no dialogue"]
            },
            scripts: [
                "“I feel a trust crack. I want to verify before concluding.”",
                "“I’m not deciding tonight. I’m giving us 24 hours to clarify.”",
                "“I’m verifying because I care, not because I want to punish you.”"
            ],
            repairProtocol: [
                "1) No instant flip: 24-hour buffer before verdict",
                "2) Ask one verification question",
                "3) Say care + standard together",
                "4) Distribute warmth outside the relationship (reduce obsession)"
            ],
            growthPath: "Keep devotion, add transition buffering and fairness. Obsession turns into trust.",
            loveInsight: "A fortress can protect your partner—or trap them. Keep the gates usable."
        }
    }
};
